import React, { useState, useEffect } from 'react';
import { Button } from "@/components/ui/button";
import { Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
import { enableTracking, disableTracking } from '../../lib/posthog';

const CONSENT_KEY = 'nf_cookie_consent';

export function getConsent() {
  try {
    return localStorage.getItem(CONSENT_KEY);
  } catch {
    return null;
  }
}

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = getConsent();
    if (!consent) {
      // Small delay so it doesn't flash on page load
      const timer = setTimeout(() => setVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    enableTracking();
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_KEY, 'declined');
    disableTracking();
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[100] p-4 md:p-6 animate-in slide-in-from-bottom duration-500">
      <div className="container mx-auto max-w-3xl">
        <div className="bg-white border border-primary/15 rounded-2xl shadow-2xl p-5 md:p-6">
          <div className="flex items-start gap-4">
            <div className="hidden sm:flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
              <Shield className="h-5 w-5 text-primary" />
            </div>
            <div className="flex-1 space-y-3">
              <div>
                <h3 className="font-semibold text-foreground text-sm md:text-base">Vi bruker informasjonskapsler</h3>
                <p className="text-muted-foreground text-xs md:text-sm leading-relaxed mt-1">
                  Vi bruker informasjonskapsler for å forbedre din opplevelse og analysere trafikken på nettsiden.
                  Ingen personlige data deles med tredjeparter.{' '}
                  <Link to="/kundeservice" className="text-primary underline underline-offset-2 hover:text-primary/80">
                    Les mer
                  </Link>
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">
                <Button
                  onClick={handleAccept}
                  className="bg-primary hover:bg-primary/90 text-white rounded-full px-6 h-9 text-sm font-medium shadow-sm"
                >
                  Godta alle
                </Button>
                <Button
                  onClick={handleDecline}
                  variant="outline"
                  className="rounded-full px-6 h-9 text-sm font-medium border-primary/20 hover:bg-primary/5 hover:text-primary"
                >
                  Kun nødvendige
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
